import Vue from 'vue'
import Router from 'vue-router'
// import Index from '@/views/Index'
// import IndexM from '@/views/IndexM'
// import Research from '@/views/Research/Index'
// import researchContent from '@/views/Research/Content'
// import Broadcast from '@/views/Broadcast/Index'
// import Walker from '@/views/School/Walker'
// import Operating from '@/views/School/Foundation '
// import Operating from '@/views/School/Operating'
// import pdfDowload from '@/views/pdfDowload/index'// 静态页面
// import About from '@/views/About/Index'
// import AboutM from '@/views/About/IndexM'
// import Wait from '@/views/Wait/Wait'
// import con1 from '@/views/Research/ContentR/index1'
// import con2 from '@/views/Research/ContentR/index2'
// import con3 from '@/views/Research/ContentR/index3'
// import con4 from '@/views/Research/ContentR/index4'
// import con5 from '@/views/Research/ContentR/index5'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/wait',
      name: 'Wait',
      // component: Wait
      component (resolve) {
        require(['@/views/Wait/Wait'], resolve)
      }
    },
    {
      path: '/',
      name: 'Index',
      component (resolve) {
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
          require(['@/views/IndexM'], resolve)
        } else {
          require(['@/views/Index'], resolve)
        }
      }
    },
    {
      path: '/research',
      name: 'Research',
      component (resolve) {
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
          require(['@/views/Research/IndexM'], resolve)
        } else {
          require(['@/views/Research/Index'], resolve)
        }
      }
    },
    {
      path: '/research/content',
      name: 'Content',
      component (resolve) {
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
          require(['@/views/Research/ContentM'], resolve)
        } else {
          require(['@/views/Research/Content'], resolve)
        }
      }
    },
    {
      path: '/broadcast',
      name: 'Broadcast',
      component (resolve) {
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
          require(['@/views/Broadcast/IndexM'], resolve)
        } else {
          require(['@/views/Broadcast/Index'], resolve)
        }
      }
    },
    {
      path: '/walker',
      name: 'Walker',
      component (resolve) {
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
          require(['@/views/School/WalkerM'], resolve)
        } else {
          require(['@/views/School/Walker'], resolve)
        }
      }
    },
    {
      path: '/operating',
      name: 'Operating',
      component (resolve) {
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
          require(['@/views/School/OperatingM'], resolve)
        } else {
          require(['@/views/School/Operating'], resolve)
        }
      }
    },
    {
      path: '/store',
      name: 'store',
      component (resolve) {
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
          require(['@/views/School/storeM'], resolve)
        } else {
          require(['@/views/School/store'], resolve)
        }
      }
    },
    {
      path: '/topic',
      name: 'topic',
      component (resolve) {
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
          require(['@/views/School/topicM'], resolve)
        } else {
          require(['@/views/School/topic'], resolve)
        }
      }
    },
    {
      path: '/live',
      name: 'live',
      component (resolve) {
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
          require(['@/views/School/topicM'], resolve)
        } else {
          require(['@/views/School/live'], resolve)
        }
      }
    },
    {
      path: '/foundation',
      name: 'Foundation',
      component (resolve) {
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
          require(['@/views/School/foundationM'], resolve)
        } else {
          // require(['@/views/School/Foundation'], resolve)
        }
      }
    },
    {
      path: '/about',
      name: 'About',
      component (resolve) {
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
          require(['@/views/About/IndexM'], resolve)
        } else {
          require(['@/views/About/Index'], resolve)
        }
      }
    },
    // 空白咨询
    {
      path: '/advisory',
      name: 'Advisory',
      component (resolve) {
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
          require(['@/views/Advisory/IndexM'], resolve)
        } else {
          require(['@/views/Advisory/Index'], resolve)
        }
      }
    },
    {
      path: '/pdfDowload',
      name: 'pdfDowload',
      // component: pdfDowload
      component (resolve) {
        require(['@/views/pdfDowload/index'], resolve)
      }
    },
    {
      path: '/content1',
      name: 'content1',
      // component: con1
      component (resolve) {
        require(['@/views/Research/ContentR/index1'], resolve)
      }
    },
    {
      path: '/content2',
      name: 'content2',
      // component: con2
      component (resolve) {
        require(['@/views/Research/ContentR/index2'], resolve)
      }
    },
    {
      path: '/content3',
      name: 'content3',
      // component: con3
      component (resolve) {
        require(['@/views/Research/ContentR/index3'], resolve)
      }
    },
    {
      path: '/content4',
      name: 'content14',
      // component: con4
      component (resolve) {
        require(['@/views/Research/ContentR/index4'], resolve)
      }
    },
    {
      path: '/content5',
      name: 'content5',
      // component: con5
      component (resolve) {
        require(['@/views/Research/ContentR/index5'], resolve)
      }
    },
    {
      path: '/download',
      name: 'download',
      // component: con5
      component (resolve) {
        require(['@/views/download'], resolve)
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// router.beforeEach((to, from, next) => {
//   if (!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
//     window.location.href = '/'
//     return
//   }
//   next()
// })



// WEBPACK FOOTER //
// ./src/router/index.js